
interface ExperienceProps {
  experience: {
    id: number;
    company: string;
    companyLink?: string;
    duration: string;
    position: string;
    description: string[];
  };
}

function Experience({ experience }: ExperienceProps) {
  return (
    <div
      key={experience?.id}
      className="bg-[#1a1a1d] lg:min-h-52 rounded-lg  hover:bg-[#1f1f23] flex flex-col md:flex-row lg:flex-row  "
    >
      <div className="basis-1/4 min-h-full p-6 rounded-md bg-[#016e86] text-left">
        <h3 className="text-xl font-bold text-gray-100">
          {experience.position}
        </h3>
        <span className="text-gray-400 text-xl md:text-lg cursor-pointer">
          <a
            href={experience.companyLink ?? "#"}
            target="0"
            className="hover:text-indigo-400"
          >
            {experience.company}
          </a>
        </span>
        <span className="block md:hidden lg:hidden text-sm text-gray-400">
          {experience.duration}
        </span>
      </div>

      <div className="basis-3/4 flex justify-between p-6 ">
        <div className="basis-4/5 md:pr-3 text-justify">
          <ul className="list-disc list-inside text-gray-400 text-left">
            {experience.description.map((item, idx) => (
              <li key={idx} className="mb-1">
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="min-h-full  basis-1/5 hidden md:block lg:block text-sm">
          {experience.duration}
        </div>
      </div>
    </div>
  );
}

export default Experience;
